import axiosInstance from '../axiosInterceptor/axiosInstance'

const updateGameday = async ({ orgId, gamedayId, data }) => {
  const url = `v1/orgs/${orgId}/gamedays/${gamedayId}`
  const response = await axiosInstance.patch(url, JSON.stringify(data))
  return response?.data
}

export default updateGameday